var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MyHttpClient } from '../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EntityService } from '../entity.service';
import { SvoService } from '../svo.service';
import * as i0 from "@angular/core";
import * as i1 from "../http-client.service";
import * as i2 from "../entity.service";
import * as i3 from "../svo.service";
var CustomerDetailsService = /** @class */ (function () {
    function CustomerDetailsService(http, entityService, svoService) {
        this.http = http;
        this.entityService = entityService;
        this.svoService = svoService;
        this.server = "" + environment.server;
        this.getCustomer = this.server + '/api/getCustomerByMobile';
        this.getWalletBalances = this.server + '/api/getWalletBalances';
        this.debitPreference = this.server + '/api/debitPreference';
        this.getPrevDueTransactions = this.server + '/api/getPrevDueTransactions';
        this.getPassDetails = this.server + '/api/getPassDetails';
        this.getLastLogin = this.server + '/api/getLastLoginDate';
        this.getReferrals = this.server + '/api/referralDetails';
        this.getTicketsUrl = this.server + '/api/tickets';
        this.paymentUrl = environment.server + '/api/payments';
    }
    CustomerDetailsService.prototype.getCustomerByMobile = function (mobile) {
        return this.http.get(this.getCustomer + '/' + mobile).pipe(catchError(this.handleError));
    };
    CustomerDetailsService.prototype.getCustomerWallets = function (customerDetails, walletList) {
        var payload = {
            user: customerDetails,
            wallets: walletList
        };
        return this.http.post(this.getWalletBalances, payload).pipe(catchError(this.handleError));
    };
    CustomerDetailsService.prototype.getDebitPreference = function (customerDetails) {
        var payload = {
            user: customerDetails,
        };
        return this.http.post(this.debitPreference, payload).pipe(catchError(this.handleError));
    };
    CustomerDetailsService.prototype.getPassInfo = function (userId) {
        return this.http.get(this.getPassDetails + '/' + userId).pipe(catchError(this.handleError));
    };
    CustomerDetailsService.prototype.getLastLoginDate = function (userId) {
        return this.http.get(this.getLastLogin + '/' + userId).pipe(catchError(this.handleError));
    };
    CustomerDetailsService.prototype.getReferralDetails = function (userId) {
        return this.entityService.getReferralDetailsV2(userId, this.entityService.USER_TYPE.CUSTOMER)
            .map(function (res) {
            res.referral = res.result || {};
            return [res.referral.referralCode];
        });
        // return this.http.get(this.getReferrals + '/' + userId).pipe(catchError(this.handleError));
    };
    CustomerDetailsService.prototype.getTickets = function (id) {
        return this.http.get(this.getTicketsUrl + '/' + id).pipe(catchError(this.handleError));
    };
    CustomerDetailsService.prototype.customerRefundDetails = function (refundObj, userId, logData) {
        var requestBody = {
            refundObj: refundObj,
            userId: userId,
            logData: logData
        };
        return this.http.post(this.paymentUrl + '/refund', requestBody).pipe(catchError(this.handleError));
    };
    CustomerDetailsService.prototype.customerDebitDetails = function (debitObject, userId, logData) {
        var requestBody = {
            debitObject: debitObject,
            userId: userId,
            logData: logData
        };
        return this.http.post(this.paymentUrl + '/debit', requestBody).pipe(catchError(this.handleError));
    };
    CustomerDetailsService.prototype.getPreviousDueTransactions = function (userData, userId) {
        var payload = {
            user: userData,
            userId: userId
        };
        return this.http.post(this.getPrevDueTransactions, payload).pipe(catchError(this.handleError));
    };
    CustomerDetailsService.prototype.getCustomerSegment = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.svoService.getCustomerSegment(id)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CustomerDetailsService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        // return an observable with a user-facing error message
        return throwError(error);
    };
    CustomerDetailsService.ngInjectableDef = i0.defineInjectable({ factory: function CustomerDetailsService_Factory() { return new CustomerDetailsService(i0.inject(i1.MyHttpClient), i0.inject(i2.EntityService), i0.inject(i3.SvoService)); }, token: CustomerDetailsService, providedIn: "root" });
    return CustomerDetailsService;
}());
export { CustomerDetailsService };
